var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F56E14",
    d: "M4.261 10.085l1.27 1.2c1.066 1.001 2.146 1.939 3.324 2.43-.852.464-1.77.252-2.68.12-1.722-1.686-2.094-3.898-1.914-3.75zm-.075-2.377c3.079 1.368 6.205 2.186 9.462 1.654l-.047.125c-.516 1.356-1.273 2.921-3.593 3.946-3.34-.815-3.89-3.242-5.947-3.984.012-.559.084-1.21.125-1.741zM3.63 9.96c.06 1.185.571 2.278 1.245 3.338-.379-.08-2.013-.906-2.32-1.872.01-.851.476-1.228 1.075-1.466zm-2.3-4.35c.504.654 1.217 1.179 2.037 1.609l.332.167-.138 2.086c-.743-.03-1.18.681-1.564 1.435C1.12 9.326.637 7.627 1.33 5.61zm12.061-.584c.841 1.315.608 2.61.477 3.295-1.03 1.383-7.28.041-9.477-1.214.011-.76.33-1.48.933-2.16 2.55.66 4.704-1.604 8.067.079zM4.805 1.684l-.197.813c-.17.745-.255 1.492.197 2.247-.46.587-.714 1.302-.967 2.017-1.152-.48-1.924-1.136-2.215-2.017 1.016-1.923 2.239-2.762 3.182-3.06zm5.738.139l.09.058c.622.407 1.069.74 1.34 1 .285.272.61.684.973 1.237-2.318-1.133-5.037.578-7.36.43 1.55-1.746 3.171-2.72 4.957-2.725zm-1.032-.45C7.699 1.717 6.34 2.76 5.22 4.119c-.487-.751.29-2.453.24-2.726C6.94.818 8.263.928 9.51 1.374z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.9a4a36470a7b179c33766f2e4b6eb2d2.svg";
export { ForwardRef as ReactComponent };